export default "__VITE_ASSET__CqxPDNWY__"